import type { DictionarySelectFragment } from '@graphql/__generated__/graphql';

type DictionaryLabelEntry = {
  readonly name: string;
  readonly label?: string | null;
};

export const sortDictionaryByLabel = (
  a: DictionarySelectFragment,
  b: DictionarySelectFragment,
): number =>
  (a.label ?? a.name).localeCompare(b.label ?? b.name, undefined, {
    sensitivity: 'base',
  });

export const getDictionaryLabel = (
  value: string,
  dictionaries: readonly DictionaryLabelEntry[] = [],
  fallback = value,
) =>
  dictionaries.find(dictionary => dictionary.name === value)?.label ?? fallback;

export const getDictionaryLabels = (
  values: readonly string[] | null | undefined,
  dictionaries: readonly DictionaryLabelEntry[] = [],
) => values?.map(value => getDictionaryLabel(value, dictionaries)) ?? [];
